import { render, staticRenderFns } from "./Reauthorize.vue?vue&type=template&id=f899dac6&scoped=true"
import script from "./Reauthorize.vue?vue&type=script&lang=js"
export * from "./Reauthorize.vue?vue&type=script&lang=js"
import style0 from "./Reauthorize.vue?vue&type=style&index=0&id=f899dac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f899dac6",
  null
  
)

export default component.exports